import { ApiError } from "./api";

export const NETWORK_ERROR_MESSAGE = "Network error, please try again";

/** What a failed request should tell the user: the server's message, or a generic line for network drops. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message || NETWORK_ERROR_MESSAGE;
  return NETWORK_ERROR_MESSAGE;
}

const handled = new WeakSet<object>();

/**
 * Claims an error for the caller's own UI (an inline message, ConfirmDialog), so the global mutation toast skips it.
 * This is the per-call opt-out: `mutate(vars, { onError })` options are invisible to the MutationCache.
 */
export function markErrorHandled(err: unknown): void {
  if (typeof err === "object" && err !== null) handled.add(err);
}

export function isErrorHandled(err: unknown): boolean {
  return typeof err === "object" && err !== null && handled.has(err);
}
